import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "../../../../../../../base/buttons/button/index.js";
import * as S from "./styled.js";
const DesktopPassengersFooter = (props)=>{
    const { literals , onClick  } = props;
    const { ageAtTravelTimeLabel ='' , acceptLabel =''  } = literals ?? {};
    if (!ageAtTravelTimeLabel && !acceptLabel) return null;
    return /*#__PURE__*/ _jsxs(S.Footer, {
        "data-testid": "PassengersFooter",
        className: "passengers-footer",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "passengers-footer-text",
                children: ageAtTravelTimeLabel
            }),
            acceptLabel && /*#__PURE__*/ _jsx(Button, {
                variant: "primary",
                size: "small",
                onClick: onClick,
                children: acceptLabel
            })
        ]
    });
};
export default DesktopPassengersFooter;

//# sourceMappingURL=index.js.map